<ch-auto-multi-select
  [placeholder]="placeholder"
  [allOptions]="allItems"
  [(selectedIds)]="selectedIds"
  [displayValue]="displayItem"
  [sortBy]="sortBy"
  [useFormStyles]="useFormStyles"
  [compact]="compact"
>
</ch-auto-multi-select>
